import type { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { LEGAL_CONSENT_KEYS, LEGAL_DOCUMENT_PATHS, type LegalAudience } from '@/constants/legal';

interface LegalConsentCheckboxProps {
  audience: LegalAudience;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
}

interface DocumentLinkProps {
  href: string;
  children?: ReactNode;
}

function DocumentLink({ href, children }: DocumentLinkProps) {
  return (
    <a href={href} target="_blank" rel="noreferrer" className="text-zooprimary underline">
      {children}
    </a>
  );
}

export function LegalConsentCheckbox({ audience, isChecked, onChange }: LegalConsentCheckboxProps) {
  const { t } = useTranslation('legal');
  return (
    <label className="flex items-start gap-2.5 text-sm text-zooindigo">
      <input
        type="checkbox"
        className="mt-1 h-4 w-4 shrink-0 accent-zooprimary"
        checked={isChecked}
        onChange={function toggle(changeEvent) {
          onChange(changeEvent.target.checked);
        }}
      />
      <span>
        <Trans
          t={t}
          i18nKey={LEGAL_CONSENT_KEYS[audience]}
          components={{
            terms: <DocumentLink href={LEGAL_DOCUMENT_PATHS.terms_of_service} />,
            dpa: <DocumentLink href={LEGAL_DOCUMENT_PATHS.data_processing_agreement} />,
            portalTerms: <DocumentLink href={LEGAL_DOCUMENT_PATHS.client_portal_terms} />,
            privacy: <DocumentLink href={LEGAL_DOCUMENT_PATHS.privacy_notice} />,
          }}
        />
      </span>
    </label>
  );
}
